<template>
  <div id="promote_dialog">
    <div
      class="app-modal"
      id="pushdiscount"
      style="z-index:999999999;"
      v-if="ishow"
    >
      <div class="app-modal-wrap">
        <div
          class="app-modal pushdiscount-dialog"
          id="activity-model-dialog"
          style="z-index:999999999;justify-content:center;display:flex;"
        >
          <div
            class="app-modal-wrap"
            style="align-self:center;display:flex;flex-direction:column;position:relative"
          >
            <i class="close-icon-new" :class="[env=='www'?'close':'close'+env]" @click="close"></i>

  <a :href="url" target="_blank">
                       <div class="backgroud-div" :class="[env=='www'?'bg':'bg'+env]">
                                <div style="position: absolute; bottom: 240px; left: 115.5px;">
                                    <div style="font-size: 24px; width: 122px; height: 67px;"><div style="margin-bottom: 3px; font-weight: bolder; color: white; " id="amount0">{{amount0}}</div><div style="color: #f15a10; font-size: 14px; font-weight: normal; " id="tip0">{{tip0}}</div></div>
                                </div>
                                <div style="position: absolute; bottom: 240px; left: 254.5px;">
                                    <div style="font-size: 24px; width: 122px; height: 67px;"><div style="margin-bottom: 3px; font-weight: bolder; color: white; " id="amount1">{{amount1}}</div><div style="color: #f15a10; font-size: 14px; font-weight: normal; " id="tip1">{{tip1}}</div></div>
                                </div>
                                <div style="position: absolute; bottom: 165px; left: 115.5px;">
                                    <div style="font-size: 24px; width: 122px; height: 67px;"><div style="margin-bottom: 3px; font-weight: bolder; color: white; " id="amount2">{{amount2}}</div><div style="color: #f15a10; font-size: 14px; font-weight: normal; " id="tip2">{{tip2}}</div></div>
                                </div>
                                <div style="position: absolute; bottom: 165px; left: 254.5px;">
                                    <div style="font-size: 24px; width: 122px; height: 67px;"><div style="margin-bottom: 3px; font-weight: bolder; color: white; " id="amount3">{{amount3}}</div><div style="color: #f15a10; font-size: 14px; font-weight: normal; " id="tip3">{{tip3}}</div></div>
                                </div>
                                <div class="countdown" style=" margin-left: 8px; left: 144px;">
                                    <div id="hour" class="hour" style="    margin: 10px 25px;margin-left: 0px;">
                                        <span id="hour1" style="color: #ff063a" class="fontweight">{{hour1}}</span>
                                        <span id="hour2" style="color: #ff063a" class="fontweight">{{hour2}}</span>
                                    </div>
                                    <div class="minute" style=" margin: 10px 0px; margin-left: 13px;">
                                        <span id="minute1" style="color: #ff063a" class="fontweight">{{minute1}}</span>
                                        <span id="minute2" style="color: #ff063a" class="fontweight">{{minute2}}</span>

                                    </div>
                                    <div class="second" style="margin: 10px 0px; margin-left: 36px;">
                                        <span id="second1" style="color: #ff063a" class="fontweight">{{second1}}</span>
                                        <span id="second2" style="color: #ff063a" class="fontweight">{{second2}}</span>

                                    </div>
                                    <div class="essecond" style="margin: 10px 0px; margin-left: 36px;">
                                        <span id="essecond1" style="color: #ff063a" class="fontweight">{{essecond1}}</span>
                                        <span id="essecond2" style="color: #ff063a" class="fontweight">{{essecond2}}</span>
                                    </div>
                                </div>
                            </div>
                            </a>
            
       

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapActions, mapMutations, mapState } from "vuex";
import config from "@/assets/script/config/index.js";
export default {
  name: "promotedialogDD",
  components: {},
  props: ["endTime", "buyType",'vouchers'],
  data() {
    return {
      ishow: true,
      hour1:0,
      hour2:0,
      minute1: 0,
      minute2: 0,
      second1: 0,
      second2: 0,
      essecond1: 0,
      essecond2: 0,
      discount: 10,
      LimitedTimeEnd: "",
      activityCountdownFunTimer: null,
      url: "",
     env:'www',
     amount0:'',
     amount1:'',
     amount2:'',
     amount3:'',
     tip0:'',
     tip1:'',
     tip2:'',
     tip3:'',
    };
  },
  watch: {
    // $route(to) {}
  },
  computed: {
    //    userInfo() {
    //         return this.$store.state.user.user;
    //     }
  },
  mounted() {
      var url = location.host;
      if(url.indexOf('preview')>-1){
        this.env='preview';
      } if(url.indexOf('d-')>-1){
        this.env='dev';
      }
           if (this.vouchers && this.vouchers.length > 0) {
                        for (var i = 0; i < this.vouchers.length; i++) {
                          this['amount'+i]=this.vouchers[i].amount
                          this['tip'+i]=this.vouchers[i].tip
                            // $("#amount"+i).html(this.vouchers[i].amount);
                            // $("#tip"+i).html(this.vouchers[i].tip);
                        }

                    }
    this.LimitedTimeEnd = this.endTime;
    this.url =
      config.account + "/member?m=vip&p=5ce&b=up&r=0&buytype=" + this.buyType;
    this.activityCountdownFunTimer = setInterval(() => {
      this.activityCountdownFun();
    }, 13);
  },
  updated() {},
  methods: {
    close() {
      this.ishow = false;
      clearInterval(this.activityCountdownFunTimer);
    },
    activityCountdownFun() {
      var currentDate = new Date();
      var strEndTime = this.LimitedTimeEnd; // store.get("LimitedTimeEnd"); //"2021-07-15 15:40"// Site_INFO.ActivityEndTime;//"2021-07-25 14:50";
      var EndTime = new Date(strEndTime);
      var days = EndTime - currentDate;
      if (days < 0) {
        clearInterval(this.activityCountdownFunTimer);
        return;
      }

      var longtime = parseInt(days); //精确到秒

      var hour = Math.floor(longtime / 60 / 60 / 1000);
      var minute = Math.floor((longtime - hour * 60 * 60 * 1000) / 1000 / 60);
      var second = Math.floor(
        (longtime - hour * 60 * 60 * 1000 - minute * 60 * 1000) / 1000
      );
      var milliSecond = Math.floor(
        longtime - hour * 60 * 60 * 1000 - minute * 60 * 1000 - second * 1000
      );
      hour = hour >= 0 ? hour : 0;
      minute = minute >= 0 ? minute : 0;
      second = second >= 0 ? second : 0;
      milliSecond = milliSecond >= 0 ? milliSecond : 0;
      if (second <= 0 && minute <= 0) {
        milliSecond = 0;
        this.close();
        //$("#pushdiscount").hide();
      }
          this.hour1=parseInt(hour % 100 / 10);
    this.hour2=parseInt(hour % 100 % 10);
      this.minute1 = parseInt((minute % 100) / 10);
      this.minute2 = parseInt((minute % 100) % 10);
      this.second1 = parseInt((second % 100) / 10);
      this.second2 = parseInt((second % 100) % 10);
      this.essecond1 = parseInt((milliSecond % 100) / 10);
      this.essecond2 = parseInt((milliSecond % 100) % 10);
    }
  }
};
</script>

<style lang="less" scoped>
.app-modal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: table;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.3);
    transition: opacity 0.2s ease;
    font-family: "Microsoft YaHei";
    line-height: 1.5;
}
.app-modal-wrap {
    display: table-cell;
    text-align: center;
    vertical-align: middle;
}
.pushdiscount-dialog .bg{
 background: url(https://s0.5118img.com/assist/images/activity/limitedtime/pushdiscount.png) no-repeat;

}
.pushdiscount-dialog .bgpreview{
 background: url(https://p-s0.5118.com/assist/images/activity/limitedtime/pushdiscount.png) no-repeat;

}
.pushdiscount-dialog .bgdev{
 background: url(http://dev.5118.com/assist/images/activity/limitedtime/pushdiscount.png) no-repeat;

}
.pushdiscount-dialog .close{
 background: url(https://s0.5118img.com/assist/images/activity/limitedtime/close.png) no-repeat;

}
.pushdiscount-dialog .closepreview{
 background: url(https://p-s0.5118.com/assist/images/activity/limitedtime/close.png) no-repeat;

}
.pushdiscount-dialog .closedev{
 background: url(http://dev.5118.com/assist/images/activity/limitedtime/close.png) no-repeat;

}

.pushdiscount-dialog .backgroud-div {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    justify-content: center;
    // background: url(https://s0.5118img.com/assist/images/activity/limitedtime/pushdiscount.png) no-repeat;
    // background: url(http://dev.5118.com/assist/images/activity/limitedtime/pushdiscount.png) no-repeat;
    width: 496px;
        height: 507px;
        line-height: inherit;
}

.close-icon-new {
        // background: url(https://s0.5118img.com/assist/images/activity/limitedtime/close.png) no-repeat;
        // background: url(http://dev.5118.com/assist/images/activity/limitedtime/close.png) no-repeat;
        height: 42px;
        width: 42px;
        position: absolute;
        align-self: flex-end;
        cursor: pointer;
        top: 160px;
        right: 16px;
        z-index: 999999999;
    }

    .tip {
        position: absolute;
        bottom: 181px;
        font-size: 20px;
        font-weight: bolder;
        color: white;
        letter-spacing: 3px;
    }

    .countdown {
        position: absolute;
        bottom: 90px;
        display: flex;

        .second {
            margin: 0 15px;
        }

        span {
            // background-color: #F95856;
            color: #F95856;
            display: inline-block;
            padding: 0;
            font-size: 18px;
            border-radius:3px;
        }
    }

    .buybtn {
        position: absolute;
        bottom: 40px;

        a {
            color: white;
            padding: 10px 60px;
            border-radius: 20px;
            background-image: linear-gradient(to right, #fcc26f, #f49941);
        }
    }
    .member-discount-tip {
    position: absolute!important;
    bottom: 181px!important;
    font-size: 20px!important;
    font-weight: bolder!important;
    color: white!important;
    letter-spacing: 3px!important;
}
.fontweight {
    font-weight: bolder;
}
.righti {
    border-left: 0;
    border: 5px solid transparent;
    border-top: 5px solid white;
    width: 5px;
    height: 5px;
    display: inline-block;
    margin-left: 5px;
    transform: rotate(270deg);
}
.ifont {
    font: 13px/1.5 "Lantinghei SC", "Open Sans", Arial, "Hiragino Sans GB", "Microsoft YaHei", STHeiti, "WenQuanYi Micro Hei", SimSun, sans-serif;
}
</style>
